// extracted by mini-css-extract-plugin
module.exports = {"image2":"styles_image2__3RfKE","title":"styles_title__1pxE1","paragraph":"styles_paragraph__3qW7i"};